<!--  FINANCE UPDATE  -->

<div class="update-demo">
	<!--  CONTAINER  -->

	<div class="container">
		<!--  HEADER  -->

		<div class="heading align-center">
			<h1>Finance Update Demonstration</h1>
			<p>Choose which finance application update you would like to trigger.</p>
		</div>

		<!--  END HEADER  -->

		<!-- FINANCE UPDATE FORM  -->

		<form [formGroup]="options_form" (submit)="onUpdate()" class="form">
			<ui-select-control
				[form]="options_form"
				[form_control]="options_form.controls['update_type']"
				[label]="'Update Type'"
				[options]="update_types"
				[empty_allowed]="false"
			></ui-select-control>
		</form>

		<!--  END FINANCE UPDATE FORM  -->
	</div>

	<!--  END CONTAINER  -->
</div>

<!-- END FINANCE UPDATE  -->
